export default __webpack_public_path__ + "static/media/icon-notifications.32e0c737.svg";